import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { tokens } from '../../AssetOrderSheet.tokens';

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.timestampBadge.fontSize}px;
`;

export const StyledTimestampBadge = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: ${tokens.timestampBadge.gap}px;
    padding: ${tokens.timestampBadge.padding}px;
    border-radius: 999px;
    background-color: rgb(255, 255, 255, 0.1);
`;

export const EmojiIcon = styled.p`
    ${typographyBase};
`;

export const Label = styled.p`
    ${typographyBase};
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: rgb(255, 255, 255, 0.5);

    span {
        color: white;
    }
`;
